/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Event_Outside_WindowInputs */



/**
* | output |
* | --- |
* | "Outside the 12-month window — does not accrue" |
*
* @param {Partner_Admin_Commission_Event_Outside_WindowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_event_outside_window = /** @type {((inputs?: Partner_Admin_Commission_Event_Outside_WindowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Event_Outside_WindowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Außerhalb des 12-Monats-Zeitraums — läuft nicht auf")
	return /** @type {LocalizedString} */ ("Outside the 12-month window — does not accrue")
});